import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RestoreFromTrashIcon(props: IconProps) {
    return <Icon {...props} iconKey={"restore_from_trash"}/>
}
